import {
    GET_ERRORS
} from './type';
import seller from '../Models/seller';

export const buyerChangePassword = (sellerData, history) => dispatch => {
    // let i=[];
    seller.createChangePassword(sellerData)
        .then(res => {
            if (parseInt(res.data.status) === 200) {
                history.push('/buyer-dashboard');
            } else {
                dispatch({
                    type: GET_ERRORS,
                    payload: res.data.message
                })
            }

        })
        .catch(

        )
};